import { NgClass } from '@angular/common';
import { Component, effect, input, model, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { ultraAnimations } from '../../../animations';
import { UltraNavigationItem } from '../../../models/ultra-navigation-item.model';
import { FocusDirective } from '../../../directives/focus.directive';
import { ActiveDirective } from '../../../directives/active.directive';
import { ActiveDarkenDirective } from '../../../directives/active-darken.directive';

@Component({
	selector: 'div[ultra-menu-item-expandable]',
	templateUrl: 'ultra-menu-item-expandable.component.html',
	styleUrls: ['ultra-menu-item-expandable.component.scss'],
	imports: [
		MatIconModule,
		TranslocoModule,
		NgClass,
		FocusDirective,
		ActiveDarkenDirective,
	],
	animations: ultraAnimations,
})
export class UltraMenuItemExpandableComponent {
	activeRoute = input<string>();
	item = input<UltraNavigationItem>();
	expanded = model(false);
	expandedMenuId = output<string>();

	// ngAfterViewInit() {
	// 	if (
	// 		this.item()
	// 			.children?.map((item) => item.link)
	// 			.includes(this.activeRoute())
	// 	) {
	// 		this.expanded.set(true);
	// 	}
	// }

	onExpand() {
		this.expanded.set(!this.expanded());
		if (this.expanded()) {
			this.expandedMenuId.emit(this.item().id);
		}
	}
}
